var translation = window['langArr'][window['language']];

window['resultsParse'] = function(data, globalGameId, gameStatus, v4ResultsMode) {

    if (!data) {
        return;
    }
    if (!data.length && data.Data) {
        if (data.Data.BingoResults) {
            data = data.Data.BingoResults;
        }
    }
    if (!data.length) {
        return;
    }

    var excludeGameId = globalGameId != null && globalGameId !== '' ? String(globalGameId) : '';
    var renderedCount = 0;

    $('#results').empty();
    var ballColors = {
        'red': [1, 9, 17, 25, 33, 41],
        'green': [2, 10, 18, 26, 34, 42],
        'blue': [3, 11, 19, 27, 35, 43],
        'purple': [4, 12, 20, 28, 36, 44],
        'brown': [5, 13, 21, 29, 37, 45],
        'yellow': [6, 14, 22, 30, 38, 46],
        'orange': [7, 15, 23, 31, 39, 47],
        'silver': [8, 16, 24, 32, 40, 48]
    };

    var askForResults = 10;
    if (data.length < 10) {
      askForResults = data.length;
    }
    for (n = 0; n < askForResults; n++) {

        var gameNumbers = data[n].GameNumbers;
        var balls =  gameNumbers.split("|").filter(function(e){return e});

        var gameId = data[n].ID_Today;
        var jackpot = data[n].GameJackPotCode;
        var ballsArr = [];
        var first5Sum = 0;
        
        for (b = 0; b < balls.length; b++) {
            var ball = balls[b]
            //console.log(first5Sum)
            if(b < 5){
                 first5Sum += Number(ball);
            }
           
            for (var key in ballColors) {
                if (ballColors[key].indexOf(parseInt(balls[b])) >= 0) {
                    ballsArr.push(balls[b]+'|'+key);
                }
            }
        }

        firstOddEven = Number(balls[0]) % 2 ? 'Odd' : 'Even';
        if (v4ResultsMode) {
            if (excludeGameId === '' || String(gameId) !== excludeGameId) {
                $('#results').append(resultsHtml(gameId, jackpot, ballsArr, first5Sum, firstOddEven, moreOddEven(balls)));
                renderedCount++;
            }
        } else if (globalGameId !== gameId) {
            $('#results').append(resultsHtml(gameId, jackpot, ballsArr, first5Sum, firstOddEven, moreOddEven(balls)));
        }

    }

    if (v4ResultsMode && renderedCount === 0
        && (String(gameStatus) === '1' || String(window.currentGameDisplayStatus) === '1')) {
        var pendingText = translation['results_after_draw'] || 'Results will be available after the draw completes.';
        $('#results').append(
            '<div class="results-box results-box-pending">' +
                '<div class="results-box-body"><p class="results-pending-msg">' + pendingText + '</p></div>' +
            '</div>'
        );
    }
}

function resultsHtml(gameId, jackpot, balls, first5Sum, firstOddEven, moreOddEven) {
    var html = '<div class="results-box">'+
                    '<div class="header-bar">'+
                        '<div class="results-title-left" >' + translation['game'] + ': <span>'+gameId+'</span></div>'+
                        '<div class="results-title-right">' + capitalize (translation['jackpot']) + ': <span>'+jackpot+'</span></div>'+
                        '<div class="clearfix"></div>'+
                    '</div>'+
                    '<div class="results-box-body">'+
                        '<div class="result-box-left">'+
                            '<div class="result-box-left-title">'+
                            translation['for_draw'] + ': <span>'+gameId+'</span>'+
                            '</div>'+
                            '<div class="result-box-left-balls">'+
                                '<ul>';
                                  
                                   for (i = 0; i < balls.length; i++) {
                                       var ball = balls[i].split('|');
                                       html += '<li ><div class="draw-number">'+(i+1)+'.</div>';
                                       html += '<div class="result-ball '+ball[1]+'-ball" ><div class="ticket-ball-number">'+Number(ball[0])+'</div></div></li>';
                                   }
                                  
                               html += '</ul>'+
                            '</div>'+
                        '</div>'+
                        '<div class="result-box-right">'+
                            '<div class="result-box-right-first">'+
                                '<div class="result-box-right-title">'+
                                    translation['win']+
                                '</div>'+
                                '<div class="clearfix"></div>'+
                                '<div class="body">'+
                                    '<div class="result-right-row" data-name="prebal-sum">'+
                                        '<div class="label">' + translation['preballs_sum'] + '</div>'+
                                        '<div class="result">'+
                                            '<div class="text">'+first5Sum+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="first-ball24">'+
                                        '<div class="label">' + translation['first_ball'] + ' (24.5) </div>'+
                                        '<div class="result">'+
                                            '<div class="text">'+parseInt(balls[0].split('|')[0])+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="first-evenodd">'+
                                        '<div class="label">' + translation['first_ball'] + ' ' + translation['even'].toLowerCase() + '/' + translation['odd'].toLowerCase() + '</div>'+
                                        '<div class="result">'+
                                             '<div class="text">'+getEvenOdd(balls[0].split('|')[0]) +'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="first-color">'+
                                        '<div class="label">' + translation['first_ball'] + ' '+ translation['color'] + '</div>'+
                                        '<div class="result">'+
                                            '<div class="text">'+capitalize(translation[balls[0].split('|')[1]])+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="more-evenOdd">'+
                                        '<div class="label">' + translation['more_even'] + '/' + translation['odd'].toLowerCase() + '</div>'+
                                        '<div class="result">'+
                                            '<div class="text">'+translation[moreOddEven.toLowerCase()]+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                            '<div class="result-box-right-second">'+
                                '<div class="result-box-right-title">'+
                                    translation['win']+
                                '</div>'+
                                '<div class="clearfix"></div>'+
                                '<div class="body">'+
                                     '<div class="result-right-row" data-name="last-ball24">'+
                                        '<div class="label">' + translation['last_ball'] + ' (24.5)</div>'+
                                        '<div class="result">'+
                                            '<div class="text">'+parseInt(balls[balls.length-1].split('|')[0])+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="last-evenOdd">'+
                                        '<div class="label">' + translation['last_ball']  + ' ' + translation['even'].toLowerCase() +  '/' + translation['odd'].toLowerCase() + '</div>'+
                                        '<div class="result">'+
                                             '<div class="text">'+getEvenOdd(balls[balls.length-1].split('|')[0])+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="last-color">'+
                                        '<div class="label">' + translation['first_ball'] + ' '+ translation['color'] + '</div>'+
                                        '<div class="result">'+
                                            '<div class="text">'+capitalize(translation[balls[balls.length-1].split('|')[1]])+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                     '<div class="result-right-row" data-name="top-colors">'+
                                        '<div class="label">' + translation['top_color'] + '</div>'+
                                        '<div class="result">'+
                                           '<div class="text">'+topColors(balls).toLowerCase()+'</div>'+
                                            '<div class="clearfix"></div>'+
                                        '</div>'+
                                        '<div class="clearfix"></div>'+
                                    '</div>'+
                                '</div>'+
                            '</div>'+
                        '</div>'+
                        '<div class="clearfix"></div>'+
                        '<div class="bottom-status">' + translation['closed'] + '<span></span></div>'+
                    '</div>'+
                '</div>';
                return html;
}

function moreOddEven(numbers) {
    var filtered = numbers.filter(function(element, index, array) {
      return (Number(element) % 2 === 0);
    });
    return parseInt(filtered.length) > parseInt(numbers.length / 2) ? 'Even' : 'Odd';
}

function getEvenOdd(number) {
    return Number(number) % 2 === 0 ? translation['even'] : translation['odd'];
}

function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

function topColors(balls) {
    var colors = [];
    var maxColor = [];
    var biggestColor = '';

    for (i = 0; i < balls.length; i++) {
         var ball = balls[i].split('|');
         var color = ball[1];
         colors[color] = colors[color] || [];
         colors[color].push(Number(ball[0]));
    }

    for (var key in colors) {
        maxColor.push({'color' : translation[key], 'val' : colors[key].length}) 
    }

    maxColor.sort(function (a, b) {
        return b.val - a.val;
    });

    for (var i = 0; i < maxColor.length; i++) {
        if(maxColor[0].val == maxColor[i].val){
            biggestColor += capitalize(maxColor[i].color) +' ';
        }
    }

    if(biggestColor.split(' ').length > 3){
       return '<span style="font-size:12px">'+ biggestColor + '</span>';
    } else {
      return biggestColor; 
    }
}

function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
}



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/js/results.js
// module id = 873
// module chunks = 0